import React, { useState, useEffect } from 'react';
import { Rnd } from 'react-rnd';

const MIN_RESIZE = { width: 40, height: 40 };
const MAX_RESIZE = { width: 800, height: 800 };

const signatureOnPdf = ({ setSignatureParams, signatureBytes, defaultPosition }) => {
  const [imagePosition, setImagePosition] = useState({ x: 0, y: 0 });
  const [size, setSize] = useState();
  const [url, setUrl] = useState();
  const [imageParams, setImageParams] = useState();

  useEffect(() => {
    if (typeof setSignatureParams === 'function') {
      setSignatureParams(imageParams);
    }
  }, [imageParams]);

  useEffect(() => {
    setUrl(getUrl(signatureBytes));
    setDefaultImageSize();
  }, [signatureBytes]);

  useEffect(() => {
    const res = {
      bytes: signatureBytes,
      signatureSize: size,
      signaturePosition: imagePosition,
    };
    setImageParams(res);
  }, [signatureBytes, imagePosition, size]);

  const getUrl = (bytes) => {
    const blob = new Blob([bytes]);
    const url = URL.createObjectURL(blob);
    return url;
  };

  const setDefaultImageSize = () => {
    const img = new Image();
    img.src = getUrl(signatureBytes);
    img.onload = () => {
      setSize({
        width: checkMinMax(MIN_RESIZE.width, MAX_RESIZE.width, img.naturalWidth),
        height: checkMinMax(MIN_RESIZE.height, MAX_RESIZE.height, img.naturalHeight),
      });
    };
  };

  const checkMinMax = (min, max, value) => {
    if (value >= min && value <= max) {
      return value;
    } else {
      return value < min ? min : max;
    }
  };

  return size ? (
    <Rnd
      bounds="parent"
      default={{
        ...defaultPosition,
        ...size,
      }}
      style={{
        border: 'dashed 1px black',
        backgroundImage: `url(${url})`,
        backgroundSize: '100% 100%',
      }}
      onDragStop={(e, d) => {
        setImagePosition({ x: d.x, y: d.y });
      }}
      onResizeStop={(e, direction, ref, delta, position) => {
        setSize({
          width: ref.offsetWidth,
          height: ref.offsetHeight,
        });
        setImagePosition({ x: position.x, y: position.y });
      }}
    />
  ) : null;
};

export default signatureOnPdf;
